// Entry point for the mat IIFE bundle.
// Re-exports everything from mat + base so the single bundle
// provides all symbols needed by the client and worker.
export * from './index';
export * from '@educraft/base';
